import { Directive, Input, TemplateRef } from '@angular/core';

// Marks an <ng-template> as the cell renderer for a given column key.
// Usage: <ng-template appColumnCell="name" let-row>...</ng-template>
@Directive({ selector: '[appColumnCell]' })
export class ColumnCellDirective {
	@Input('appColumnCell') key: string;

	constructor(public template: TemplateRef<any>) {}
}
